export const LOCALES = {
  ru: "ru-RU",
  en: "en-UK",
};
